import { OidcSecurityService, OpenIDImplicitFlowConfiguration, OidcConfigService, AuthWellKnownEndpoints } from 'angular-auth-oidc-client';
import { environment } from '../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { createTranslateLoader } from './core/translation/loader-factory';
import { isPlatformBrowser } from '@angular/common';
export function loadConfig(oidcConfigService) {
    console.log('APP_INITIALIZER STARTING');
    return function () { return oidcConfigService.load_using_custom_stsServer("https://" + environment.aadConfig.tenant + ".b2clogin.com/" + environment.aadConfig.tenant + ".onmicrosoft.com/v2.0/.well-known/openid-configuration?p=" + environment.aadConfig.signin_signup_policy); };
}
var ɵ0 = (createTranslateLoader);
var AppModule = /** @class */ (function () {
    function AppModule(oidcSecurityService, oidcConfigService, platformId, translate) {
        var _this = this;
        this.oidcSecurityService = oidcSecurityService;
        this.oidcConfigService = oidcConfigService;
        this.platformId = platformId;
        this.translate = translate;
        this.translate.use('en');
        if (isPlatformBrowser(platformId)) {
            this.oidcConfigService.onConfigurationLoaded.subscribe(function () {
                var openIDImplicitFlowConfiguration = new OpenIDImplicitFlowConfiguration();
                openIDImplicitFlowConfiguration.stsServer = environment.aadConfig.stsServer;
                openIDImplicitFlowConfiguration.redirect_url = environment.aadConfig.redirect_url;
                openIDImplicitFlowConfiguration.client_id = environment.aadConfig.client_id;
                openIDImplicitFlowConfiguration.response_type = environment.aadConfig.response_type;
                openIDImplicitFlowConfiguration.start_checksession = false;
                openIDImplicitFlowConfiguration.silent_renew = false;
                openIDImplicitFlowConfiguration.scope = environment.aadConfig.scope;
                openIDImplicitFlowConfiguration.post_logout_redirect_uri = environment.aadConfig.post_logout_redirect_uri;
                openIDImplicitFlowConfiguration.post_login_route = environment.aadConfig.post_login_route;
                openIDImplicitFlowConfiguration.forbidden_route = environment.aadConfig.forbidden_route;
                openIDImplicitFlowConfiguration.unauthorized_route = environment.aadConfig.unauthorized_route;
                openIDImplicitFlowConfiguration.auto_userinfo = false;
                openIDImplicitFlowConfiguration.log_console_warning_active = true;
                openIDImplicitFlowConfiguration.log_console_debug_active = false; //!environment.production;
                openIDImplicitFlowConfiguration.max_id_token_iat_offset_allowed_in_seconds = 3600;
                openIDImplicitFlowConfiguration.storage = localStorage;
                var authWellKnownEndpoints = new AuthWellKnownEndpoints();
                authWellKnownEndpoints.setWellKnownEndpoints(_this.oidcConfigService.wellKnownEndpoints);
                _this.oidcSecurityService.setupModule(openIDImplicitFlowConfiguration, authWellKnownEndpoints);
            });
        }
        console.log('APP STARTING');
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
